/*@ngInject*/
const RemoteFunction = function (formMediator) {

    this.executeFunction = function (formId, fieldId, rowIndex, parameters, submissionId) {
        parameters.rowIndex = rowIndex;

        return formMediator.executeFunction(formId, submissionId, parameters.beanName, fieldId, parameters);
    };

};
angular.module('umCore')
    .service('remoteFunction', RemoteFunction);
